import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Event } from '@src/api/types/event.ts';
import { MediaCategory } from '@src/api/types/mediaCategory';
import { MediaTag } from '@src/api/types/mediaTag';
import { Pagination } from '@src/api/types/pagination.ts';
import { TenantUser } from '@src/api/types/tenantUser';

type EventIndexRequest = {
  keyword?: string;
  category_slug?: string;
  tag_slug?: string;
  event_progress?: string;
  reception_status?: number;
  page?: number;
  per_page?: number;
};

export type EventIndexResponseData = Event & {
  reception_status: number;
  media_category: MediaCategory;
  media_tags: MediaTag[];
};

type EventIndexResponse = {
  data: EventIndexResponseData[];
  pagination: Pagination;
};

export type CompanyEventShowResponse = {
  id: number;
  published_at: string;
  tenant_user: TenantUser;
  media_category: MediaCategory;
  media_tags: MediaTag[];
  title: string;
  description: string;
  content: string;
  thumbnail_url: string;
  reception_status: number;
  reception_status_text: string;
  status: number;
  pdf_url: string;
  original_pdf_name: string;
  event_start_at: string;
  event_end_at: string;
  recruitment_start_at: string;
  recruitment_end_at: string;
  application_url: string;
  is_top_display: boolean;
};

export const companyEventApiClient = {
  index: async (params: EventIndexRequest = {}): Promise<ApiResult<EventIndexResponse>> => {
    return await axiosClient.get('/company/events', { params });
  },
  show: async (id: number): Promise<ApiResult<CompanyEventShowResponse>> => {
    return await axiosClient.get(`/company/events/${id}`);
  },
};
